import React from 'react';

import type { ColorCatalog } from 'src/modules/designStudio/types';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

import { ColorPicker } from '../../ColorPicker';

export const ColorCatalogPicker = ({
  colorCatalog,
  selectedGroup,
  selectedColorIndex,
  onGroupSelected,
  onColorSelected,
}: {
  colorCatalog: ColorCatalog;
  selectedGroup: string;
  selectedColorIndex: number;
  onGroupSelected: (group: string) => void;
  onColorSelected: (index: number) => void;
}) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  const colorGroupLabelColors: Record<string, string> = {};
  Object.keys(colorCatalog).forEach(group => {
    colorGroupLabelColors[group] = colorCatalog[group][0].hex;
  });

  const groups = [...Object.keys(colorCatalog)];

  const items = colorCatalog[selectedGroup].map(color => ({
    color: color.hex,
    group: selectedGroup,
    name: color.name,
    trim: false,
  }));

  return (
    <ColorPicker
      changeColor={color => {
        const index = colorCatalog[selectedGroup].findIndex(
          c => c.hex === color.color,
        );
        onColorSelected(index);
      }}
      groupLabelColors={colorGroupLabelColors}
      groups={groups}
      header={t('menu.filters.color')}
      items={items}
      selectedColor={colorCatalog[selectedGroup][selectedColorIndex].hex}
      selectedColorName={colorCatalog[selectedGroup][selectedColorIndex].name}
      selectedGroup={selectedGroup}
      setColorGroup={onGroupSelected}
    />
  );
};
